import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import {
  Route,
  BrowserRouter,
  NavLink,
  Switch,
  withRouter,
} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import api from "../../../utility/api/api.js";
import { holdReasonAction, actionProcessingJobs } from "../../../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { notify } from "react-notify-toast";
import loader from "../../../images/loader.gif";

class HoldReasons extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, isLoading: false };
    this.masterData = JSON.parse(localStorage.getItem("getMasterData"));
    this.toggle = this.toggle.bind(this);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
      }
    });
  }
  componentWillMount() {
    api.holdreasonsList(this);
  }

  toggle = async (data, e) => {
    if (data === "HOLD") {
      if (document.querySelector("input[name='holdreason']:checked")) {
        let reason = document.querySelector("input[name='holdreason']:checked")
          .value;

        // const orderIds = localStorage.getItem("ordersArr");
        // if (orderIds && orderIds.length > 0) {
        this.setState({ isLoading: true });
        const resp = await api.holdOrders(this.props.order_id, reason);
        if (resp && resp[0] && resp[0].status == "success") {
          await api.callShippingJobs(this, this.props.trip_id);
          console.log("gaaaa3", resp);
        }
        this.setState({ isLoading: false });
        this.props.history.push("/intransit");

        // } else {
        //   notify.show("Select Orders", "error");
        // }
      } else {
        this.setState({ error: "Please Select the field" });
        e.preventDefault();
        return;
      }
    }
    this.setState({
      modal: !this.state.modal,
      error: "",
    });
  };

  render() {
    console.log("this.props==hold", this.props);
    if (this.props && this.props.holdData) {
      return (
        <BrowserRouter>
          <div>
            <NavLink
              onClick={this.toggle}
              to="/intransit/holdorder"
              className="orderAnchor"
            >
              HOLD
            </NavLink>
            <Switch>
              <Route path="/intransit/holdorder">
                <Modal
                  isOpen={this.state.modal}
                  backdrop={"static"}
                  keyboard={false}
                  fade={false}
                  toggle={this.toggle}
                  className={this.props.className}
                >
                  <ModalHeader className="justify-content-center py-2 alert-secondary">
                    Reason to {this.props.label}
                  </ModalHeader>
                  <ModalBody>
                    <div className="select-reason-title">SELECT REASON</div>
                    {this.props &&
                      this.props.holdData &&
                      this.props.holdData[0] &&
                      this.props.holdData[0].data &&
                      this.props.holdData[0].data.reasons.map((obj, key) => (
                        <div key={key}>
                          <div>
                            <input
                              className="with-gap custom-check"
                              onChange={(e) => this.setState({ error: "" })}
                              value={obj.reason}
                              id={`delay_${key}`}
                              name="holdreason"
                              type="radio"
                            />
                            <Label htmlFor={`delay_${key}`}>{obj.reason}</Label>
                          </div>
                        </div>
                      ))}
                    <div className="text-danger">{this.state.error}</div>
                  </ModalBody>
                  <ModalFooter className="p-0 border-0">
                    <span className="col-6 text-center">
                      <NavLink to="/intransit">
                        <button
                          className="btn bg-white m-0 py-2"
                          onClick={this.toggle}
                        >
                          Cancel
                        </button>
                      </NavLink>
                    </span>
                    <span className="col-6 text-center">
                      {this.state.isLoading ? (
                        <img src={loader} height="40px" />
                      ) : (
                        <div
                          className="m-0 py-2 modalbutton"
                          exact
                          // to="/intransit"
                          onClick={(e) => this.toggle(this.props.label, e)}
                        >
                          OK, Done
                        </div>
                      )}
                    </span>{" "}
                  </ModalFooter>
                </Modal>
              </Route>
            </Switch>
          </div>
        </BrowserRouter>
      );
    } else {
      return null;
      // (
      //   <div>
      //     <Button onClick={this.toggle}>{this.props.label}</Button>
      //   </div>
      // );
    }
  }
}
function mapStateToProps(state) {
  console.log("holdDetails", state);
  return {
    holdData: state.getholdreasons,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      holdReasonAction: holdReasonAction,
      actionProcessingJobs: actionProcessingJobs,
    },
    dispatch
  );
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HoldReasons)
);



// WEBPACK FOOTER //
// ./src/components/Intransit/ViewTripList/HoldReasons.js